module.exports = __webpack_public_path__ + "media/rent-home-people.0e6ab745.png";